export default __webpack_public_path__ + "static/media/wedding1.0e59f194.webp";